<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:10px;">Acknowledgement</h1>
<p>Once again, I must thank Austin Macauley for their invaluable assistance in producing this book – thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?447a7d96